// extracted by mini-css-extract-plugin
export default {"disableFocusOutline":"clickable-div-module__disableFocusOutline--XF7Ms"};